"use client";

import { c as _c } from "react/compiler-runtime";
import type { FC } from "react";
import { useLayoutEffect } from "react";
import { applyHeaderHeight, SITE_HEADER_ATTRIBUTE } from "../../_helpers/header-height";
const siteHeaderSelector = `[${SITE_HEADER_ATTRIBUTE}]`;
export const HeaderHeight: FC = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  useLayoutEffect(_temp, t0);
  return null;
};
function _temp() {
  const header = document.querySelector(siteHeaderSelector);
  if (!(header instanceof HTMLElement)) {
    return;
  }
  const sync = () => {
    applyHeaderHeight(document.documentElement.style, header.getBoundingClientRect().height);
  };
  sync();
  if (typeof ResizeObserver === "undefined") {
    return;
  }
  const observer = new ResizeObserver(sync);
  observer.observe(header);
  return () => observer.disconnect();
}